//抛出websocket对象
export default {
    ws: {},
    setWs: function (newWs) {
        this.ws = newWs
    }    
}
